import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ServicesSection } from '../components/ServicesSection';
import { AboutSection } from '../components/AboutSection';
import { WhoWeServe } from '../components/WhoWeServe';
import { ProductCategories } from '../components/ProductCategories';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-551">
      <Header data-id="element-552" />
      <main data-id="element-553">
        <Hero data-id="element-554" />
        <ServicesSection data-id="element-555" />
        <AboutSection data-id="element-556" />
        <WhoWeServe data-id="element-557" />
        <ProductCategories data-id="element-558" />
        <WhyChooseUs data-id="element-559" />
        <TestimonialsSection data-id="element-560" />
        <ContactSection data-id="element-561" />
      </main>
      <Footer data-id="element-562" />
    </div>;
}